"use client";

import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { ReminderSwitchProperties } from "@website/ticket-ui/common/components/flight-reminder/reminder-switch-box/types";
import { Switch } from "@website/ui/switch";
export const ReminderSwitchClient: React.FC<ReminderSwitchProperties> = properties => {
  const $ = _c(8);
  const {
    checked,
    onClick
  } = properties;
  const isTour = process.env.NEXT_PUBLIC_APP_NAME === "tour";
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div><MaterialIcon className="text-secondary text-2xl" name="notifications_active" variant="outlined" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="text-on-surface-high-emphasis text-subtitle-2">موجود شد اطلاع بده</p>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex-1 gap-1">{t1}<p className="text-on-surface-medium-emphasis text-caption">{isTour ? "\u0627\u0637\u0644\u0627\u0639\u200C\u0631\u0633\u0627\u0646\u06CC \u062F\u0631\u0635\u0648\u0631\u062A \u0645\u0648\u062C\u0648\u062F \u0634\u062F\u0646 \u062A\u0648\u0631" : "\u0627\u0637\u0644\u0627\u0639\u200C\u0631\u0633\u0627\u0646\u06CC \u062F\u0631 \u0635\u0648\u0631\u062A \u0645\u0648\u062C\u0648\u062F \u0634\u062F\u0646 \u067E\u0631\u0648\u0627\u0632 \u062F\u0631 \u0627\u06CC\u0646 \u062A\u0627\u0631\u06CC\u062E"}</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== checked) {
    t3 = <div onClick={_temp}><Switch checked={checked} color="secondary" onChange={_temp2} /></div>;
    $[3] = checked;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onClick || $[6] !== t3) {
    t4 = <div className="shadow-1 flex w-full items-center gap-2 rounded-lg bg-white px-4 py-3" onClick={onClick}>{t0}{t2}{t3}</div>;
    $[5] = onClick;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
function _temp(event) {
  event.preventDefault();
}
function _temp2() {}